export var MessageModifiers;
(function (MessageModifiers) {
    MessageModifiers["Change"] = "change";
    MessageModifiers["Accepted"] = "accepted-bet";
    MessageModifiers["Tax"] = "tax";
    MessageModifiers["Purchase"] = "purchase";
})(MessageModifiers || (MessageModifiers = {}));
//# sourceMappingURL=MessageModifiers.js.map